import { combineReducers } from "redux";
import customerReducer from "./customer";
import storeReducer from "./store";
import menuReducer from "./menu";
import cartReducer from "./cartReducer";
import paymentReducer from "./payment";

const rootReducer = combineReducers({
  customer: customerReducer,
  store: storeReducer,
  menu: menuReducer,
  cart: cartReducer,
  payment: paymentReducer
});

export default rootReducer;
